import { EntityModel } from '@/interfaces'
import {
  ALL_USERS_QUERY,
  CREATE_USER_MUTATION,
  DELETE_USER_MUTATION,
  FORCE_DELETE_USER_MUTATION,
  SINGLE_USER_QUERY,
  UPDATE_USER_MUTATION,
} from './graphql'
import rbacRoleEntity from '@/entities/rbacRole/entity'

const userModel: EntityModel = {
  name: 'user',
  namePlural: 'users',
  uniqueName: 'user',
  uniqueNamePlural: 'users',
  path: 'iam/user',
  baseUrl: '/iam/users',
  translationPrefix: 'entities:user.',
  getDisplayName: (values: any) => {
    return `${values.firstName} ${values.lastName}`
  },
  gql: {
    getAll: ALL_USERS_QUERY,
    getSingle: SINGLE_USER_QUERY,
    create: CREATE_USER_MUTATION,
    update: UPDATE_USER_MUTATION,
    delete: DELETE_USER_MUTATION,
    forceDelete: FORCE_DELETE_USER_MUTATION,
  },
  attributes: {
    email: {
      name: 'email',
      label: 'entities:user.attributes.email.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'email',
        },
      ],
    },
    firstName: {
      name: 'firstName',
      label: 'entities:user.attributes.firstName.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    lastName: {
      name: 'lastName',
      label: 'entities:user.attributes.lastName.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    role: {
      name: 'role',
      label: 'entities:user.attributes.role.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return rbacRoleEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default userModel
